import { makeAction } from "async-action-creator";
import api from "../../utils/api";
import { createApiThunk } from "../../utils/thunk";

export const FETCH_OPPORTUNITIES = makeAction(
  "opportunities/FETCH_OPPORTUNITIES"
);

export const FETCH_NOTIFICATIONS = makeAction(
  "opportunities/FETCH_NOTIFICATIONS"
);

export const fetchOpportunities = createApiThunk({
  action: FETCH_OPPORTUNITIES,
  request: (_, { company }, dispatch) => {
    dispatch(fetchNotifications());
    return api.opportunities.fetch(company.id);
  }
});

export const fetchNotifications = createApiThunk({
  action: FETCH_NOTIFICATIONS,
  start: false,
  request: (_, { company }) => api.opportunities.notifications(company.id)
});
